import { Button, Text } from '@sketch/components'
import { breakpoint } from '@sketch/global-styles/src/breakpoints'

import styled, { css, keyframes } from 'styled-components'

const pulseYellow = keyframes`
  0%,
  100% {
    opacity: 0.3;
    transform: scale(0.95);
  }
  25% {
    opacity: 1;
    transform: scale(1.05);
  }
  50%,
  75% {
    opacity: 0.3;
    transform: scale(0.95);
  }
`

const pulseBlue = keyframes`
  0%,
  25% {
    opacity: 0.3;
    transform: scale(0.95);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  75%,
  100% {
    opacity: 0.3;
    transform: scale(0.95);
  }
`

const pulseRed = keyframes`
  0%,
  50% {
    opacity: 0.2;
    transform: scale(0.95);
  }
  75% {
    opacity: 0.6;
    transform: scale(1.05);
  }
  100% {
    opacity: 0.2;
    transform: scale(0.95);
  }
`

const lightStyles = css`
  position: absolute;
  width: 153px;
  height: 158px;
  filter: blur(40px);
`

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  flex: 0 0 176px;
  margin-top: 64px; /* stylelint-disable-line scales/space */
  padding: 24px;
  background: ${({ theme }) => theme.colors.background.tertiary.D};
  color: ${({ theme }) => theme.colors.foreground.secondary.B};
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radii.xxxlarge};

  ${breakpoint('base', 'md')`
    flex: 0 0 max-content;
  `}

  /* 
    This is a small white gradient that renders at the bottom of the banner
    to create a subtle effect and make it look like the banner is fading out 
  */
  ::after {
    content: '';
    position: absolute;
    bottom: -30px;
    right: 110px;
    width: 300px;
    height: 40px;
    background-color: ${({ theme }) => theme.colors.background.secondary.B};
    filter: blur(24px);

    ${breakpoint('base', 'sm')`
        display: none;
    `}
  }
`

export const Title = styled(Text).attrs({
  textStyle: 'header.primary.G',
})``

export const Description = styled(Text).attrs({
  textStyle: 'secondary.standard.F',
})`
  max-width: 640px;
  margin-top: 0;
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
`

export const IllustrationContainer = styled.div`
  position: absolute;
  top: 15px;
  right: 90px;
  width: 326px;
  height: 217px;
  z-index: -1;
  transition: opacity 0.3s ease-in-out;

  ${breakpoint('sm', 'lg')`
    opacity: 0.45;
  `}

  ${breakpoint('base', 'sm')`
    display: none;
  `}
`

export const StyledButton = styled(Button)`
  background: transparent;

  /* Override global styles */
  &&&& {
    margin-left: 0;
  }

  border: none;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  transition: background-color 0.15s
    ${({ theme }) => theme.transitions.timing.easeInOut};
`

export const Lights = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 327px;
  height: 100%;
`

export const LightYellow = styled.div`
  ${lightStyles}

  right: 80px;
  animation: ${pulseYellow} 4s
    ${({ theme }) => theme.transitions.timing.easeInOut} infinite;
  background: linear-gradient(
    180deg,
    rgba(255, 230, 21, 1) 0%,
    rgba(255, 200, 9, 0) 100%
  );
`

export const LightBlue = styled.div`
  ${lightStyles}

  top: 45px;
  right: -30px;
  animation: ${pulseBlue} 4s
    ${({ theme }) => theme.transitions.timing.easeInOut} infinite;

  opacity: 0.67;
  background: linear-gradient(
    180deg,
    rgba(16, 243, 241, 1) 0%,
    rgba(7, 226, 222, 0) 100%
  );
`

export const LightRed = styled.div`
  ${lightStyles}

  top: 30px;
  left: -20px;
  animation: ${pulseRed} 4s ${({ theme }) => theme.transitions.timing.easeInOut}
    infinite;
  opacity: 0.35;
  background: linear-gradient(
    180deg,
    rgba(255, 21, 21, 1) 0%,
    rgba(255, 9, 9, 0) 100%
  );
`
